import { useRef } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import ls from "../../Localization";

interface TextInputProps extends Omit<TextFieldProps, "onChange"> {
	id: string;
	name: string;
	value: any;
	hideLabel?: boolean;
	onChange(id: string, value: any): void;
	errors?: any;
}

const ls2: any = ls;

export function TextInput({
	id,
	name,
	errors,
	onChange,
	value,
	variant,
	hideLabel,
	...rest
}: TextInputProps) {
	const inputRef = useRef(null);

	const error = errors ? errors[id] : undefined;

	return (
		<TextField
			id={id}
			inputRef={inputRef}
			label={hideLabel ? undefined : ls2[name]}
			fullWidth
			variant={variant as any}
			helperText={error}
			error={!!error}
			placeholder={ls2[name + "Placeholder"]}
			onChange={e => onChange(id, e.target.value)}
			value={value}
			{...rest}
		/>
	);
}

export default TextInput;
